const riot = require('riot');

riot.tag2('atom-input-raffle-patterns', '<div class="ts-hs text-navy mb32" if="{opts.heading}">{opts.heading}</div> <div class="f fm mxn8"> <div class="px8 text-gray_60 ts-hxs bold {col.class}" each="{col in cols}"> <div class="f fm"> <div class="flex-fixed">{col.label}</div> <div class="text-pink_70 flex-fixed ml8" if="{col.required}">必須</div> </div> </div> </div> <div class="mxn8"> <div class="f fm border-bottom border-gray_10 {p.is_fallback &amp;&amp; opts.isAllWin ? &quot;hide&quot; : &quot;&quot;}" each="{p, p_i in patterns}"> <div class="px8 py12 {col.class}" each="{col, i in cols}"> <div class="f fm w-full {col.itemClass}"> <div class="text-gray_80 ts-hxs bold" if="{!col.input &amp;&amp; !col.button}">{col.getText ? col.getText(p, p_i) : p[col.key]}</div> <div class="w0 flex-auto" if="{col.input}"> <input class="input w-full text-right" if="{!p.is_fallback}" type="{col.input.type || &quot;text&quot;}" inputmode="numeric" required="{col.required}" pattern="{col.input.pattern}" title="{col.input.title}" riot-value="{col.getValue ? col.getValue(p) : getColValue(p, col)}" oninput="{updateValue.bind(null, col, p)}" data-col-index="{i}" readonly="{opts.readonly}"> <input class="input w-full text-right" if="{p.is_fallback}" readonly riot-value="{col.getFallbackValue(p)}"> </div> <div class="ts-ps text-gray_80 flex-fixed ml8" if="{col.input.unit}">{col.input.unit}</div> <button class="button w-full {col.button.class}" if="{col.button &amp;&amp; !p.is_fallback}" type="button" disabled="{col.button.getDisabled()}" onclick="{col.button.onclick.bind(null, p_i)}">{col.button.text}</button> </div> </div> </div> </div> <div class="f fm mxn8 mb8"> <div class="p8 text-gray_60 ts-hxs bold {col.class}" each="{col, i in cols}"> <div class="f fm w-full {col.itemClass}"> <div class="flex-fixed">{footerRow[i].getText ? footerRow[i].getText() : footerRow[i].text}</div> </div> </div> </div> <button class="button" if="{!opts.isEdit &amp;&amp; !opts.readonly}" disabled="{patterns.length &gt;= MAX_PATTERNS_LENGTH}" type="button" onclick="{addPattern}"><span class="icon-plus fs24 text-gray_30 mr4"></span><span>抽選結果追加</span></button>', 'atom-input-raffle-patterns,[data-is="atom-input-raffle-patterns"]{display:block}', '', function(opts) {
    const BASE_WEIGHT = 100000000;
    const RAFFLE_NAME = '抽選結果';
    this.MAX_PATTERNS_LENGTH = 6;
    this.cols = [];

    const MINIMUM_WEIGHT = 0.001;

    this.patterns = [];
    this.prevPointProviders = [];

    this.on('mount', () => {
      this.footerRow = this.getFooterRow();
      if (this.opts.patterns) {
        try {
          this.patterns = this.opts.patterns.map((p) => {
            return {
              weight: p.weight,
              amount: p.amount,
              is_fallback: p.is_fallback,
              consumed_lot: p.consumed_lot,
              max_lot: p.max_lot,
            };
          });
        }
        catch (e) {
          this.patterns = this.getDefaultPatterns();
        }
      }
      else {
        this.patterns = this.getDefaultPatterns();
      }
      this.initData();
    });

    this.on('update', () => {

      if (!app.utils.isEqualUniqueArrays(this.prevPointProviders, this.opts.pointProviders)) {
        this.prevPointProviders = this.opts.pointProviders;
        this.initData();
      }

      if (this.prevIsAllWin !== this.opts.isAllWin) {
        this.prevIsAllWin = this.opts.isAllWin;
        this.initData();
      }
    });

    this.getDefaultPattern = () => {
      return {
        amount: 0,
        is_fallback: false,
        max_lot: 0,
        weight: 0,
      };
    };

    this.getDefaultPatterns = () => {
      return [
        this.getDefaultPattern(),
        {
          amount: 0,
          is_fallback: true,
          max_lot: 0,

          weight: 0,
        }
      ];
    };

    this.addPattern = () => {
      this.patterns.push(this.getDefaultPattern());
      this.patterns.sort((a, b) => {
        if (a.is_fallback) return 1;
        if (b.is_fallback) return -1;
        return 0;
      });
      this.normalizePatterns();
      const temp = this.patterns;
      this.update({ patterns: [] });
      this.update({ patterns: temp });
      this.bubbleTrigger('datachange');
      this.bubbleTrigger('addRafflePattern', {
        index: this.patterns.length - 2,
      });
    };

    this.initData = () => {
      let amount_validation = app.utils.getInputAmountValidation(this.opts.pointProviders);

      this.cols = [
        {
          label: '抽選結果パターン',
          class: 'flex-auto w0',
          key: '',
          getText: (p, i) => {
            if (p.is_fallback) return this.opts.isAllWin ? '抽選終了' : 'ハズレ';
            return `${RAFFLE_NAME}${i + 1}`;
          },
        },
        {
          label: '当選確率',
          required: this.opts.isEdit ? false : true,
          class: `${this.opts.isEdit ? 'f fr' : ''} flex-fixed w${this.opts.isEdit ? 136 : 166}`,
          itemClass: 'f fr',
          key: 'weight',
          input: {
            validate: this.validateWeight,
            title: '0.01〜100(小数点第二位まで)で入力してください。',
            unit: '%',
          },
          getValue: (p) => {
            if (p._data && "weight" in p._data) return p._data.weight;
            return Big(p.weight).div(BASE_WEIGHT).mul(100).toString();
          },
          getFallbackValue: (p) => {
            return this.getFallbackWeight();
          },
        },
      ];

      if (this.opts.isEdit) {
        this.cols.push({
          label: '現在の発行数 / 上限数',
          class: 'f fr flex-fixed w166 ',
          itemClass: 'f fr',
          key: 'max_lot',
          getText: (p) => {
            const max_lot = p.is_fallback ? '無制限' : p.max_lot;
            return `${p.consumed_lot.toLocaleString('ja')} / ${max_lot.toLocaleString('ja')}`;
          },
        },
        {
          label: 'ポイント額',
          class: 'f fr flex-fixed w136',
          itemClass: 'f fr',
          key: 'amount',
          getText: (p) => {
            return `${p.amount.toLocaleString('ja')}円`;
          },
        },
        {
          label: '発行済み金額',
          class: 'f fr flex-fixed w136',
          itemClass: 'f fr',
          getText: (p) => {
            return `${(p.consumed_lot * p.amount).toLocaleString('ja')}円`;
          },
        },
        {
          label: '最大発行金額',
          class: 'f fr flex-fixed w136',
          itemClass: 'f fr',
          getText: (p) => {
            return `${(p.max_lot * p.amount).toLocaleString('ja')}円`;
          },
        });
      }

      else {
        this.cols.push({
          label: '上限人数',
          required: true,
          class: 'flex-fixed w166',
          itemClass: 'f fr',
          key: 'max_lot',
          input: {
            validate: this.getIntValidator({ min: 1, max: 100000000 }),
            title: '1〜100,000,000の整数を入力してください',
            unit: '人',
          },
          getFallbackValue: (p) => {
            return '無制限';
          },
        },
        {
          label: 'ポイント額',
          required: true,
          class: 'flex-fixed w166',
          itemClass: 'f fr',
          key: 'amount',
          input: {
            validate: this.getIntValidator({ min: amount_validation.min, max: amount_validation.max }),
            title: amount_validation.title || '1〜1,000,000の整数を入力してください',
            unit: '円',
          },
          getFallbackValue: (p) => {
            return '0';
          },
        },
        {
          label: '最大発行金額',
          class: 'f fr flex-fixed w136',
          itemClass: 'f fr',
          getText: (p) => {
            return `${(p._data.max_lot * p._data.amount).toLocaleString('ja')}円`;
          },
        },
        {
          label: '',
          class: 'flex-fixed w64',
          button: {
            class: 'danger p0 h44',

            getDisabled: () => {
              return this.patterns.length <= 2 || this.opts.readonly;
            },
            text: '削除',
            onclick: async (index) => {
              if (await spat.modal.confirm('本当に削除しますか？')) {
                this.patterns.splice(index, 1);
                const temp = this.patterns;
                this.update({ patterns: [] });
                this.update({ patterns: temp });
                this.bubbleTrigger('datachange');
                this.bubbleTrigger('removeRafflePattern', { index });
              }
            },
          }
        });
      }

      this.normalizePatterns();
      this.update();
    };

    this.normalizePatterns = () => {
      this.cols.forEach(col => {
        this.patterns.forEach(p => {
          if (!col.key) return ;
          p._data = p._data || {};
          p._data[col.key] = col.getValue ? col.getValue(p) : this.getColValue(p, col);
        });
      });
    };

    this.updateValue = (col, p, e) => {
      this.bubbleTrigger('datachange');
      p._data = p._data || {};
      p._data[col.key] = e.target.value;
      col.input.validate && col.input.validate(e.target);
    };

    this.getColValue = (p, col) => {
      if (p._data && col.key in p._data) {
        return p._data[col.key];
      }
      else {
        return p[col.key];
      }
    };

    this.getFallbackWeight = () => {

      if (this.opts.isAllWin) return '0';

      try {
        var v = this.patterns.reduce((num, p) => {
          if (p.is_fallback) return num;
          const v = p._data ? p._data.weight : 0;
          return num.sub(v);
        }, Big(100));
        if (v.cmp(0) === -1) return '0';
        return v.toString();
      }
      catch (e) {
        return '-';
      }
    };

    this.getValue = () => {
      const inputs = [...this.root.querySelectorAll('input[data-col-index]')];
      if (
        inputs.some(input => {
          const col = this.cols[input.dataset.colIndex];
          if (col.input.validate && col.input.validate(input)) {
            input.reportValidity();
            return true;
          }
        })
      ) return ;
      try {
        var sum_weight = this.sumWeight();
      }
      catch (e) {
        throw new Error('当選確率に不正な値が入力されています。');
      }
      if (sum_weight > 100) {
        throw new Error('当選確率は合計100以下になるように入力してください。');
      }

      if (!this.opts.isAllWin) {
        if (sum_weight > (100 - MINIMUM_WEIGHT)) {
          throw new Error(`ハズレ確率は${MINIMUM_WEIGHT.toString(10)}以上になるように入力してください`);
        }
      }

      else {
        if (sum_weight !== 100) {
          throw new Error('ハズレを取り除く場合、当選確率は合計100になるように入力してください。');
        }
      }

      return this.patterns.map(p => {
        const d = p._data;
        if (!d) return p;
        const weight = p.is_fallback ? this.getFallbackWeight() : d.weight;
        if (weight === '-') {
          throw new Error('当選確率に不正な値が入力されています。');
        }
        return {
          weight: Number(Big(weight).div(100).mul(BASE_WEIGHT)),
          amount: Number(d.amount),
          max_lot: Number(d.max_lot),
          is_fallback: p.is_fallback,
        };
      });
    };

    this.validateWeight = (input) => {
      const v = Number(input.value);
      if (Number.isNaN(v)) {
        message = '正しい数字を入力してください';
      }
      else if (v < MINIMUM_WEIGHT) {
        message = `${MINIMUM_WEIGHT.toString(10)}以上で入力してください。`;
      }
      else if (v > 100) {
        message = '100以下で入力してください。';
      }
      else if (!/^[0-9]+(\.[0-9]{0,3})?$/.test(String(v))) {
        message = '小数点第三位以内で入力してください';
      }
      else {
        message = '';
      }
      input.setCustomValidity(message);
      return message;
    };

    this.getIntValidator = ({ min = 0, max = 100 } = {}) => {
      return (input) => {
        const v = Number(input.value);
        if (Number.isNaN(v)) {
          message = '正しい数字を入力してください';
        }
        else if (v < min) {
          message = `${min}以上で入力してください。`;
        }
        else if (v > max) {
          message = `${max}以下で入力してください。`;
        }
        else if (/\./.test(String(v))) {
          message = '整数で入力してください。';
        }
        else {
          message = '';
        }
        input.setCustomValidity(message);
        return message;
      };
    };

    this.sumWeight = () => {
      const weight = this.patterns.reduce((num, p) => {
        if (p.is_fallback) return num;
        const weight = p._data ? p._data.weight : 0;
        return num.add(weight);
      }, Big(0));
      return Number(weight);
    };

    this.displaySumWeight = () => {
      const weight = this.sumWeight();

      if (!this.opts.isAllWin && Big(weight).cmp(100) === -1) return 100;
      return weight;
    };

    this.getFooterRow = () => {
      let footer_row = [
        {
          text: '合計',
        },
        {
          getText: () => {
            try {
              return this.displaySumWeight() + '%';
            }
            catch (e) {
              return '-%';
            }
          }
        },
        {
          getText: () => {
            if (!this.opts.isEdit) return '-';
            var consumed_lot = 0;
            this.patterns.forEach(p => {
              consumed_lot += p.consumed_lot;
            });
            return `${consumed_lot.toLocaleString('ja')} / 無制限`;
          }
        },
        {
          getText: () => {
            try {
              const amount = this.patterns.reduce((num, p) => {
                const amount = p._data ? p._data.amount : 0;
                return num.add(amount);
              }, Big(0));
              return `${Number(amount).toLocaleString('ja')}円`;
            }
            catch (e) {
              return '-円';
            }
          }
        },
      ];

      if (this.opts.isEdit) {
        footer_row.push(
          {
            getText: () => {
              if (!this.opts.isEdit) return '';
              var consumed_amount = 0;
              this.patterns.forEach(p => {
                consumed_amount += (p.consumed_lot * p.amount);
              });
              return `${consumed_amount.toLocaleString('ja')}円`;
            },
          },
          {
            getText: (p, i) => {
              try {
                const max_amount = this.patterns.reduce((num, p) => {
                  const amount = p._data ? p._data.amount : 0;
                  const max_lot = p._data ? p._data.max_lot : 0;

                  return num.add(Big(amount).mul(max_lot));
                }, Big(0));
                return `${Number(max_amount).toLocaleString('ja')}円`;
              }
              catch (e) {
                return '-円';
              }
            }
          },
        );
      }

      else {
        footer_row.push(
          {
            getText: (p, i) => {
              try {
                const max_amount = this.patterns.reduce((num, p) => {
                  const amount = p._data ? p._data.amount : 0;
                  const max_lot = p._data ? p._data.max_lot : 0;

                  return num.add(amount * max_lot);
                }, Big(0));
                return `${Number(max_amount).toLocaleString('ja')}円`;
              }
              catch (e) {
                return '-円';
              }
            }
          },
        );
      };

      return footer_row;
    };

    this.getPatternsLength = () => {
      return this.patterns.length;
    };
});